import React from "react";

export default function PanchashilaFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-pan21{fill:#93111d}.cls-pan22{fill:#e21d27}.cls-pan23{fill:#ddd3d3}.cls-pan24{fill:#eae4e4}.cls-pan25{fill:#c90e20}"
            }
          </style>
        </defs>
        <path
          d="M1625.76 1701.8H374.24c-55.33 0-100.34-45.01-100.34-100.34V150.66c0-55.33 45.01-100.34 100.34-100.34h1251.52c55.33 0 100.34 45.01 100.34 100.34v1450.79c0 55.33-45.01 100.34-100.34 100.34ZM374.24 88c-34.55 0-62.66 28.11-62.66 62.66v1450.79c0 34.55 28.11 62.66 62.66 62.66h1251.52c34.55 0 62.66-28.11 62.66-62.66V150.66c0-34.55-28.11-62.66-62.66-62.66H374.24Z"
          className="cls-pan21"
        />
        <path
          d="M1358.82 1622.72c-4.25-20.51 22.25-38.62 22.1-69.9-.21-43.27-51.14-101.96-281.11-166.86a532.7 532.7 0 0 1-25.4 131c-.78 2.38-1.58 4.74-2.38 7.07 43.44 19.71 86.17 39.12 129 62.87 23.16 12.95 48.32 20.56 68.07 37.72 3.67 3.2 4.67 10.28.4 13.55-13.48 8.34-28.7 5.07-42.98 5.8.5 9.49 2.24 22.98 8.16 37.16 29.38-35.7 50.8-44.27 65.4-44.89 3.71-.16 12.58-.04 24.89-2.36 14.67-2.77 26.23-7.5 33.86-11.16Z"
          className="cls-pan25"
        />
        <path
          d="M1644.18 1695.87c-100.37-82.96-264.69-20.46-283.82-68.36-1.36-3.4-3.15-10.28.77-21.57-6.93 6.54-18.01 15.48-33.46 21.97-12.73 5.35-22.6 6.58-27.93 7.61-15.76 3.04-38.12 13.14-65.06 45.62 2.36 5.64 5.38 11.4 9.24 17.05 10.97 16.02 29.5 32.3 74.33 45.61 88.54 26.3 130.53-3.29 215.35 23.31a295.394 295.394 0 0 1 51.37 21.63c7.26-8.4 15.29-16.82 24.17-25.07 21.1-19.6 41.92-33.55 59.52-43.44-4.69-5.62-12.91-14.8-24.47-24.36Z"
          className="cls-pan22"
        />
        <path
          d="M1557 1754.06c-73.94-46.62-146.46-.04-236.78-44.55-39.16-19.3-41.57-35.97-41.73-41.28-.46-15.19 14.87-23.05 21.28-32.73 0 0-.02 0-.03.01-23.56 12.48-43.66 28.69-55.87 51.52-9.1 17.68-17.51 35.82-24.87 54.32-2 11.4-8.36 20.25-4.29 33.7 10.87 35.88 78.93 42.46 115.98 46.04 59.11 5.72 73.36-5.57 114.06 3.92 40.31 9.4 69.69 30.57 87.89 46.55 5.2-11.76 11.69-24.6 19.81-38a334.17 334.17 0 0 1 37.9-50.91c-6.34-7.22-17.35-18.5-33.36-28.59Z"
          className="cls-pan24"
        />
        <path
          d="M1299.74 1635.52s.02 0 .03-.01c1.24-1.88 2.16-3.83 2.55-5.91 4.14-22.04-49.54-59.05-224.83-122.34a535.901 535.901 0 0 1-28.59 73.39c-7.79 16.32-15.9 31.2-23.95 44.63 155.45 42.25 194.75 80.25 194.61 109.95-.01 2.15-.23 4.18-.57 6.14 7.37-18.5 15.78-36.63 24.87-54.32 12.22-22.82 32.31-39.04 55.87-51.52Z"
          className="cls-pan23"
        />
        <rect
          width={10.67}
          height={688.12}
          x={1015.56}
          y={1276.92}
          className="cls-pan21"
          rx={5.33}
          ry={5.33}
          transform="rotate(17.33 1020.774 1620.721)"
        />
        <circle cx={1120.07} cy={1298.38} r={21.4} className="cls-pan21" />
        <path
          d="M641.18 1622.72c4.25-20.51-22.25-38.62-22.1-69.9.21-43.27 51.14-101.96 281.11-166.86a532.7 532.7 0 0 0 25.4 131c.78 2.38 1.58 4.74 2.38 7.07-43.44 19.71-86.17 39.12-129 62.87-23.16 12.95-48.32 20.56-68.07 37.72-3.67 3.2-4.67 10.28-.4 13.55 13.48 8.34 28.7 5.07 42.98 5.8-.5 9.49-2.24 22.98-8.16 37.16-29.38-35.7-50.8-44.27-65.4-44.89-3.71-.16-12.58-.04-24.89-2.36-14.67-2.77-26.23-7.5-33.86-11.16Z"
          className="cls-pan25"
        />
        <path
          d="M355.82 1695.87c100.37-82.96 264.69-20.46 283.82-68.36 1.36-3.4 3.15-10.28-.77-21.57 6.93 6.54 18.01 15.48 33.46 21.97 12.73 5.35 22.6 6.58 27.93 7.61 15.76 3.04 38.12 13.14 65.06 45.62a95.574 95.574 0 0 1-9.24 17.05c-10.97 16.02-29.5 32.3-74.33 45.61-88.54 26.3-130.53-3.29-215.35 23.31a295.394 295.394 0 0 0-51.37 21.63c-7.26-8.4-15.29-16.82-24.17-25.07a311.863 311.863 0 0 0-59.52-43.44c4.69-5.62 12.91-14.8 24.47-24.36Z"
          className="cls-pan22"
        />
        <path
          d="M443 1754.06c73.94-46.62 146.46-.04 236.78-44.55 39.16-19.3 41.57-35.97 41.73-41.28.46-15.19-14.87-23.05-21.28-32.73 0 0 .02 0 .03.01 23.56 12.48 43.66 28.69 55.87 51.52 9.1 17.68 17.51 35.82 24.87 54.32 2 11.4 8.36 20.25 4.29 33.7-10.87 35.88-78.93 42.46-115.98 46.04-59.11 5.72-73.36-5.57-114.06 3.92-40.31 9.4-69.69 30.57-87.89 46.55-5.2-11.76-11.69-24.6-19.81-38a334.17 334.17 0 0 0-37.9-50.91c6.34-7.22 17.35-18.5 33.36-28.59Z"
          className="cls-pan24"
        />
        <path
          d="M700.26 1635.52s-.02 0-.03-.01c-1.24-1.88-2.16-3.83-2.55-5.91-4.14-22.04 49.54-59.05 224.83-122.34 6.84 22.27 16.05 47.1 28.59 73.39 7.79 16.32 15.9 31.2 23.95 44.63-155.45 42.25-194.75 80.25-194.61 109.95.01 2.15.23 4.18.57 6.14-7.37-18.5-15.78-36.63-24.87-54.32-12.22-22.82-32.31-39.04-55.87-51.52Z"
          className="cls-pan23"
        />
        <rect
          width={10.67}
          height={688.12}
          x={973.77}
          y={1276.92}
          className="cls-pan21"
          rx={5.33}
          ry={5.33}
          transform="rotate(162.67 979.073 1621.014)"
        />
        <circle cx={879.93} cy={1298.38} r={21.4} className="cls-pan21" />
        {children}
      </g>
    </svg>
  );
}
